import { render } from "./RejectedPaymentLiquidations.vue?vue&type=template&id=3640b100"
import script from "./RejectedPaymentLiquidations.vue?vue&type=script&lang=js"
export * from "./RejectedPaymentLiquidations.vue?vue&type=script&lang=js"

import "./RejectedPaymentLiquidations.vue?vue&type=style&index=0&id=3640b100&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__